import React, { useEffect } from 'react';
import { ScrollArea } from '@mantine/core';
import { useLazyQuery } from '@apollo/client';

import ActionCardItem from '../../../../components/requests/ActionCardItem';
import { OverviewCard } from '../../../../components/common';
import { GET_ACTION_CARD_ITEMS } from '../../../../apollo/queries/priceChangeRequestActions';
import { useAuthStore } from '../../../../stores/auth.store';
import type { ActionCardItemDto } from '../../../../codegen/graphql';

type ActionsCardProps = {
    emphasizeFromDigest?: boolean;
};

function ActionsCard({ emphasizeFromDigest = false }: ActionsCardProps) {
    const { userId, standInForUserIds } = useAuthStore();

    const [fetchActions, { data, loading }] = useLazyQuery(
        GET_ACTION_CARD_ITEMS,
        {
            variables: {
                responsibleUserIds: [userId, ...standInForUserIds],
            },
            fetchPolicy: 'network-only',
            pollInterval: 30000,
        },
    );

    const actionItems = data?.getActionCardItems || [];

    useEffect(() => {
        fetchActions();
    }, [fetchActions]);

    return (
        <OverviewCard
            title={`My Actions [${actionItems.length}]`}
            isLoading={loading}
            reload={() => fetchActions()}
            wrapperClassName={
                emphasizeFromDigest
                    ? 'ring-2 ring-inset ring-primary'
                    : undefined
            }
        >
            <div className="flex flex-col gap-4 justify-start w-full h-full">
                <ScrollArea>
                    {actionItems.length ? (
                        actionItems.map(
                            (action: ActionCardItemDto, index: number) => (
                                <ActionCardItem
                                    key={action.id}
                                    action={action}
                                    hasBorder={actionItems.length - 1 !== index}
                                />
                            ),
                        )
                    ) : (
                        <div className="flex flex-1 justify-center items-center mt-16 font-medium">
                            No Action Items
                        </div>
                    )}
                </ScrollArea>
            </div>
        </OverviewCard>
    );
}

export default ActionsCard;
